import { render, staticRenderFns } from "./AdditionalMediaConfig.vue?vue&type=template&id=a0bc3096&scoped=true&"
import script from "./AdditionalMediaConfig.vue?vue&type=script&lang=js&"
export * from "./AdditionalMediaConfig.vue?vue&type=script&lang=js&"
import style0 from "./materialOwnSource.styl?vue&type=style&index=0&id=a0bc3096&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0bc3096",
  null
  
)

export default component.exports